<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-broadcast-tower" class="q-mb-sm" /> {{ $t(title_webcasts) }}
        </div>

        <q-tabs :key="webcastTabsKey" v-model="tab" color="secondary" class="shadow-1">
            <q-tab slot="title" name="event_data" :label="$t('event_data')" />
            <q-tab slot="title" name="subscribers" :label="$t('subscribers')" v-show="showTab" />
            <q-tab slot="title" name="tests" :label="$t('tests')" v-show="showTab" />
            <!-- <q-tab slot="title" name="reaction_tests" :label="$t('reaction_tests')" v-show="showTab" v-if="selected_client_params.group_training_use_evaluations" /> -->
            <q-tab slot="title" name="support_material" :label="$t('support_materials')" v-show="showTab" />
            <q-tab slot="title" name="reaction_tests" :label="$t('reaction_tests')" v-show="showTab" />
            <q-tab slot="title" name="stream" :label="$t('stream')" v-if="showTab && show_stream" />
            <q-tab slot="title" name="chat_moderation" :label="$t('chat_moderation')" v-show="showTab && show_chat_moderation" />
            <q-tab slot="title" v-if="useReviews" name="comments" :label="$t('comments')" v-show="showTab" />
            <q-tab slot="title" name="presence" :label="$t('presence')" v-show="showPresence" />

            <q-tab-pane name="event_data" class="q-px-lg q-pb-xl" keep-alive>
                <event-data @loadContent="loadContent" :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="subscribers" class="q-px-lg q-pb-xl" keep-alive>
                <subscribers :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="tests" class="q-px-lg q-pb-xl" keep-alive>
                <tests :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="support_material">
                <support-material :manageWebcasts="permissions.webcasts_manage"/>
            </q-tab-pane>

            <q-tab-pane name="reaction_tests" class="q-px-lg q-pb-xl" keep-alive>
                <reaction-tests :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="stream" class="q-px-lg q-pb-xl" keep-alive>
                <stream :id_webcast="id_webcast" />
            </q-tab-pane>

            <q-tab-pane name="chat_moderation" class="q-px-lg q-pb-xl">
                <chat-moderation :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="comments">
                <comments origin="webcast" />
            </q-tab-pane>

            <q-tab-pane name="presence">
				<presence :url="presenceUrl"/>
			</q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import EventData from 'components/admin/webcasts/EventData'
import ChatModeration from 'components/admin/webcasts/ChatModeration'
import Stream from 'components/admin/webcasts/Stream'
import Tests from 'components/admin/webcasts/TestsTab'
import ReactionTests from 'components/admin/webcasts/ReactionTests'
import Comments from 'components/admin/Comments'
import SupportMaterialTab from 'components/admin/webcasts/SupportMaterialTab'
import Subscribers from 'components/admin/webcasts/Subscribers'
import Presence from 'components/admin/presential/Presence'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'webcast', 'training', 'admin'] },

    data() {
        return {
            tab: 'event_data',
            id_webcast: null,
            show_stream: false,
            show_chat_moderation: false,
            permissions: {
                webcasts_manage: false,
            },
            presential_event_id: '',
            status: 0,
        }
    },

    components: {
        'event-data': EventData,
        'chat-moderation': ChatModeration,
        'stream': Stream,
        'tests': Tests,
        'reaction-tests': ReactionTests,
        'comments': Comments,
        'support-material': SupportMaterialTab,
        'subscribers': Subscribers,
        'presence': Presence,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_client_module_items: 'common/user_client_module_items',
			id_user_language_selected: 'common/id_user_language_selected',
            languages: 'params/languages',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        title_webcasts(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_webcasts === '' ? 'webinars' : obj.title_webcasts
				}
			}
        },

        showTab() {
            if (this.id_webcast != 0) return true
            else return false
        },

        webcastTabsKey() {
            return `webcast-${this.id_webcast}`
        },

        useReviews() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) return  obj.use_comments_webcast
            else return true
        },

        presenceUrl() {
            const language = this.languages.find((obj) => { return obj.id === this.id_user_language_selected })
            let language_code
            switch (language.code) {
                case 'pt-br':
                    language_code = 'pt-BR'
                    break;
                case 'es-es':
                    language_code = 'es'
                    break;
                case 'en-us':
                    language_code = 'en'
                    break;
                case 'fr-fr':
                    language_code = 'fr'
                    break;
            
                default:
                    language_code = 'pt-BR'
                    break;
            }
			let client = this.clients.find((client) => client.id == this.id_user_client_selected)
			return `${client.webcast_qrcode_url_prefix}?webinar_event_id=${this.id_webcast}&lng=${language_code}`
		},

        showPresence() {
			let client = this.clients.find((client) => client.id == this.id_user_client_selected)
			return (this.status == 2 || this.status == 3 || this.status == 5 || this.status == 8 || this.status === 1) && client.webcast_qrcode_url_prefix !== ''
		},
    },

    methods: {
        loadContent(content) {
            if (content.status) this.status = content.status
            this.show_stream = content.webcast_type === 2
            this.show_chat_moderation = content.use_chat === true
        },

        refreshWebcastContext(id) {
            this.id_webcast = id
            this.show_stream = false
            this.show_chat_moderation = false
        },

        checkPermissions() {
            const client = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (client) {
                for (const [key, value] of Object.entries(this.permissions)) {
                    let obj = client.module_items.find(obj => obj.slug === key)
                    if (obj) {
                        this.permissions[key] = obj.permission
                    }
                }
            } else return
        },
    },

    beforeRouteUpdate (to, from, next) {
        this.refreshWebcastContext(to.params.id)
        next()
    },

    created() {
        this.refreshWebcastContext(this.$route.params.id)
        this.checkPermissions()
    }
}
</script>

<style>

</style>
